/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ConfirmAction({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/ConfirmAction",
  onSubmit,
  isSubmitting
  
}) {
let resetPasswordConfirmSubmitData = fromData.useDataSubmit({ viewPath,
context: 'reset_password_confirm',
})
let resetPasswordConfirmIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'reset_password_confirm',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="reset_password_confirm"
 onClick={resetPasswordConfirmSubmitData}
 disabled={resetPasswordConfirmIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Confirm"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}